import api, { ApiResponse } from "./api";
import FloorPlan, { FloorPlanDTO } from "@/model/floor";
import PaginateModel, { PaginateDTO } from "@/model/paginate";

interface FaceListResponseInterface {
  meta: string;
  data: {
    data: FloorPlanDTO[];
    pagination: any;
  };
}

interface FloorList {
  paginate: PaginateDTO;
  list: FloorPlan[];
}

class FloorApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async index(query): Promise<FloorList> {
    const response = await this.getHttp().get<FaceListResponseInterface>(
      "/floor-plans",
      {
        params: query,
      }
    );

    const list = response.data.data.data.map((item) => {
      return new FloorPlan(item);
    });
    const paginate = new PaginateModel({
      page: response.data.data.pagination.current_page,
      pageCount: response.data.data.pagination.last_pages,
      start: response.data.data.pagination.current_page,
      end: response.data.data.pagination.last_pages,
      count: response.data.data.pagination.total,
    });
    return {
      list,
      paginate,
    };
  }

  async create(floor: FloorPlan): Promise<any> {
    const response = await this.getHttp().post<any>("/floor-plans", floor);

    return response.data;
  }

  async update(floor: FloorPlan): Promise<any> {
    const response = await this.getHttp().put<any>(
      "/floor-plans/" + floor.id,
      floor
    );

    return response.data;
  }

  async detail(id): Promise<any> {
    const response = await this.getHttp().get<any>("/floor-plans/" + id);
    if (response.data.meta.status === 200) {
      return new FloorPlan(response.data.data);
    }
  }
  async delete(id): Promise<ApiResponse> {
    const response = await this.getHttp().delete<any>("/floor-plans/" + id);

    return response.data;
  }
}
export default new FloorApi();
